export const Sizes: Record<string, [w: number, h: number]> = {
  small: [2, 2],
  medium: [3, 2],
  long: [4, 1],
  large: [4, 2],
};

export const Sounds: Record<string, { name: string; url: string }> = {
  "alarm-01": {
    name: "Alarm 01",
    url: "/sounds/alarm-01.wav",
  },
  "alarm-02": {
    name: "Alarm 02",
    url: "/sounds/alarm-02.mp3",
  },
  "alarm-03": {
    name: "Alarm 03",
    url: "/sounds/alarm-03.mp3",
  },
  "alarm-oversimplified": {
    name: "Oversimplified",
    url: "/sounds/alarm-oversimplified.mp3",
  },
};
